import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_22701_7097" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_22701_7097)">
      <path
        d="M10.0007 9.99996C10.459 9.99996 10.8513 9.83677 11.1777 9.51038C11.5041 9.18399 11.6673 8.79163 11.6673 8.33329C11.6673 7.87496 11.5041 7.4826 11.1777 7.15621C10.8513 6.82982 10.459 6.66663 10.0007 6.66663C9.54232 6.66663 9.14996 6.82982 8.82357 7.15621C8.49718 7.4826 8.33398 7.87496 8.33398 8.33329C8.33398 8.79163 8.49718 9.18399 8.82357 9.51038C9.14996 9.83677 9.54232 9.99996 10.0007 9.99996ZM10.0007 16.125C11.6951 14.5694 12.952 13.1562 13.7715 11.8854C14.5909 10.6145 15.0007 9.48607 15.0007 8.49996C15.0007 6.98607 14.518 5.74649 13.5527 4.78121C12.5875 3.81593 11.4034 3.33329 10.0007 3.33329C8.59787 3.33329 7.41385 3.81593 6.44857 4.78121C5.48329 5.74649 5.00065 6.98607 5.00065 8.49996C5.00065 9.48607 5.41037 10.6145 6.22982 11.8854C7.04926 13.1562 8.30621 14.5694 10.0007 16.125ZM10.0007 18.3333C7.76454 16.4305 6.0944 14.6632 4.99023 13.0312C3.88607 11.3993 3.33398 9.88885 3.33398 8.49996C3.33398 6.41663 4.00412 4.7569 5.3444 3.52079C6.68468 2.28468 8.23676 1.66663 10.0007 1.66663C11.7645 1.66663 13.3166 2.28468 14.6569 3.52079C15.9972 4.7569 16.6673 6.41663 16.6673 8.49996C16.6673 9.88885 16.1152 11.3993 15.0111 13.0312C13.9069 14.6632 12.2368 16.4305 10.0007 18.3333Z"
        fill="#333333"
      />
    </g>
  </svg>
);

export default Icon;
